import type { MembershipProduct } from "./SpaceType";

export function findUserHoldingsModule(
  products: MembershipProduct[]
): MembershipProduct | null {
  return products.find((p) => p.productKind === "user_holdings") ?? null;
}

export function isUserHoldingsSubscribed(products: MembershipProduct[]): boolean {
  const mod = findUserHoldingsModule(products);
  return mod?.userSubscribed === true;
}
